var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 1643,
    height: 361,
    viewBox: "0 0 1643 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "community-line-path",
    d: "M1.10938 177.072C96.1086 296.198 457.633 478.656 774.297 250.96C1088.6 24.9579 1188.4 304.408 1365.4 322.586C1644.37 351.237 1614.59 68.5011 1641.73 0.644531",
    stroke: "#7551FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.442b04f18b6eb5d80bbf3f5fe5e341c9.svg";
export { ForwardRef as ReactComponent };